import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioGuia } from "app/features/componentes/folioguia";
import { SelectorSimpleFactory } from "app/features/selectores/logic";
import { TipoSeguroGuia } from "app/models/requireme";

export interface Props {
    value: models.FiltroGuia;
    onChange: (value: models.FiltroGuia) => void;
    verClienteOrigen?: boolean;
}

export const importeMayorCero = SelectorSimpleFactory([
    { label: "Cero", value: false },
    { label: "Mayor a cero", value: true }
], x => x.value, x => x.label);

export const LimiteGuias = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);

/**
* Componente para editar un FiltroGuia
*/
export class FiltroGuiaComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroGuia> {
        return {};
    }


    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaInicio: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroGuia> = { FechaFinal: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    private verClienteOrigen = (props: Props) => props.verClienteOrigen;


    render() {
        const { value } = this.props;
        const verClienteOrigen = this.verClienteOrigen(this.props);
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const Datetime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Folio = getField(FolioGuia);
        const StatusFacturacion = getField(selectores.StatusFacturacion);
        const StatusGuia = getField(selectores.StatusGuia);
        const SiNo = getField(selectores.SiNo);
        const Importe = getField(importeMayorCero);
        const Acuse = getField(selectores.TipoAcuse);
        const Limite = getField(LimiteGuias);
        const TipoSeguro = getField(selectores.TipoSeguro);

        return (
            <div>
                {kea.autogrid(2, [
                    <Sucursal field="IdSucursalStatus" label="Sucursal actual" />,
                    <Sucursal field="IdSucursalOrigen" label="Sucursal origen" />,
                    <Sucursal field="IdSucursalDestino" label="Sucursal destino" />,
                    <Datetime field="FechaInicio" label="Fecha de creación (inicio)" onChange={this.onFechaDesdeChange} />,
                    <Datetime field="FechaFinal" label="Fecha de creación (final)" onChange={this.onFechaHastaChange} />,
                    <Cliente field="IdClienteDestino" label="Cliente destino" />,
                    verClienteOrigen ? <Cliente field="IdClienteOrigen" label="Cliente origen" /> : null,
                    <Folio field="Folio" />,
                    <StatusFacturacion field="StatusGuiaFacturacion" label="Status guía facturación" />,
                    <StatusGuia field="Status" label="Status" />,
                    <SiNo field="FletePorCobrar" label="FXC" />,
                    <SiNo field="EntregaDomicilio" label="EAD" />,
                    <SiNo field="RecoleccionDomicilio" label="RAD" />,
                    <Acuse field="TipoAcuse" label="Acuse" />,
                    <Importe field="ImporteMayorCero" label="Importe total" />,
                    <Limite field="Limite" label="Limite" />,
                    <SiNo field="EsCancelada" label="Cancelada" />,
                    <SiNo field="EsDeCredito" label="De crédito" />,
                    <TipoSeguro field="TipoSeguro" label="Tipo de seguro" />

                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/guias/list2/filtro.tsx